import React, {useState, useEffect} from 'react';
import "../../../css/pages/rs11foundation.scss";
import { useHistory } from 'react-router-dom';
import rs11Foundation from '../../../images/rs11Foundation.png';
import Cookies from 'js-cookie';


function RS11Foundation() {
    const history = useHistory();
    
    return(
        <div className='rs11-foundation-container'>
            <p className='title-text'>RS11 Foundation</p>
            <div className='grid-image-text'>
                <img className='rs11-foundation-image-grid' src={rs11Foundation} />
                <div>
                    <p className='content-text'>To solve the most challenging issues that we face as humanity we need to ALL lean in and harness our unique individual strengths for good for the common good, hence the motto 1+1=11.</p>
                    <p className='content-text'>
                        <span>Founded by RS11 CEO </span>
                        <span className='highlight-text'>Art Norins</span>
                        <span>, the 501(c)(3) RS11 Foundation, along with almost everyone else on Earth, deeply cares about our planet and its inhabitants.</span>
                    </p>
                    <p className='content-text'>After extensive research over many years and the assistance of numerous trusted/respected relationships, the Foundation endorses/supports the following social impact organizations:</p>
                </div>
            </div>
            <ul>
              <li className='content-text'>Exceptional organizations focusing in on Early Childhood Development (ECD) and Parent Development – “ECD Organizations”</li>  
              <li className='content-text'>Other exceptional organizations that are helping humanity – “Non-ECD Organizations”</li>
            </ul>
            <p className='content-text'>Thank you in advance for reviewing this website and considering to support some of these amazing organizations.</p>
            <p className='content-text'>
                <span>To donate, and for more information, please visit </span>
                <a className='org-text' href='http://harthub.org/' target='_blank'>rs11.org.</a>
            </p>
        </div>
    )
}

export default RS11Foundation;

